import { getIconProps, type IconProps } from '#types'

/**
 * Package icon — golf bag with a folded flap.
 *
 * Used for lesson packages / bundled-offering surfaces.
 *
 * @example
 * ```tsx
 * <PackageIcon className="size-5" />
 * ```
 */
export function PackageIcon({ strokeWidth = 2, ...props }: IconProps) {
  return (
    <svg {...getIconProps(props)} viewBox="0 0 34.212 35.0001">
      <path
        d="M18.5939 1.85517C13.6765 -0.02598 11.2343 1.11261 9.07267 6.11252C9.02316 6.19503 8.99016 6.29404 8.95716 6.39305L8.84165 6.65707L8.77564 6.82208L5.88791 13.7196C6.86148 13.3071 7.93407 13.0761 9.05616 13.0761"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7567 13.0762H25.1591C25.9512 13.0762 26.7433 13.1752 27.4858 13.4063C28.3439 11.2776 28.6079 9.57794 28.1624 8.19182C28.1294 8.05981 28.0799 7.9113 28.0139 7.76279C27.9479 7.51527 27.8324 7.28425 27.6838 7.05323C27.5683 6.83871 27.4363 6.6572 27.2713 6.45918C26.4132 5.40309 24.9941 4.52852 22.9645 3.68695L19.3177 2.15233C19.0701 2.05332 18.8391 1.93781 18.5916 1.8553"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.212 21.1291V24.3468C33.212 24.6769 33.1955 25.0069 33.179 25.3369C32.8655 31.0959 29.6478 34.0001 23.5423 34.0001H10.6712C10.2752 34.0001 9.87913 33.9671 9.4996 33.9176C4.25217 33.5711 1.44694 30.7659 1.10041 25.5184C1.05091 25.1389 1.0179 24.7429 1.0179 24.3468V21.1291C1.0179 17.8123 3.03107 14.9576 5.90231 13.72C6.89239 13.3074 7.94847 13.0764 9.07057 13.0764H25.1759C25.9845 13.0764 26.7765 13.1919 27.5026 13.4064C30.7863 14.413 33.212 17.4823 33.212 21.1291Z"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.77214 6.822L5.8844 13.7196C3.01316 14.9572 1 17.8119 1 21.1287V16.2938C1 11.6074 4.33327 7.69657 8.77214 6.822Z"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.208 16.2931V21.128C33.208 17.4977 30.7988 14.412 27.4985 13.4219C28.3566 11.2767 28.6041 9.59359 28.1916 8.19098C28.1586 8.04246 28.1091 7.89395 28.0431 7.76194C31.1123 9.34607 33.208 12.5968 33.208 16.2931Z"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
